export default __webpack_public_path__ + "static/media/Eye_bg.514156da.svg";